import { createAction, props } from '@ngrx/store';
import { Category, UpdateCategoryRequest } from '@models/category.model';

export enum CategoryActions {
  GET_CATEGORIES = '[Categories] Get categories',
  GET_CATEGORIES_SUCCESS = '[Categories] Categories fetched',
  GET_CATEGORIES_FAILED = '[Categories] Cannot fetch categories',
  UPDATE_CATEGORY = '[Categories] Update category',
  UPDATE_CATEGORY_SUCCESS = '[Categories] Category updated',
  UPDATE_CATEGORY_FAILED = '[Categories] Cannot update category',
  CREATE_CATEGORY = '[Categories] Create category',
  CREATE_CATEGORY_SUCCESS = '[Categories] Category created',
  CREATE_CATEGORY_FAILED = '[Categories] Cannot create category',
  DELETE_CATEGORY = '[Categories] Delete category',
  DELETE_CATEGORY_SUCCESS = '[Categories] Category deleted',
  DELETE_CATEGORY_FAILED = '[Categories] Cannot delete category',
  SET_CATEGORY_DETAIL = '[Categories] Set category detail',
}

export const fetchCategories = createAction(CategoryActions.GET_CATEGORIES, props<{ payload: string }>());
export const categoriesFetched = createAction(CategoryActions.GET_CATEGORIES_SUCCESS, props<{
  payload: Category[]
}>());
export const cannotFetchCategories = createAction(CategoryActions.GET_CATEGORIES_FAILED, props<{ error: string }>());
export const updateCategory = createAction(CategoryActions.UPDATE_CATEGORY, props<{
  payload: UpdateCategoryRequest
}>());
export const categoryUpdated = createAction(CategoryActions.UPDATE_CATEGORY_SUCCESS, props<{ payload: Category }>());
export const cannotUpdateCategory = createAction(CategoryActions.UPDATE_CATEGORY_FAILED, props<{ error: string }>());
export const createCategory = createAction(CategoryActions.CREATE_CATEGORY, props<{
  payload: UpdateCategoryRequest
}>());
export const categoryCreated = createAction(CategoryActions.CREATE_CATEGORY_SUCCESS, props<{ payload: Category }>());
export const cannotCreateCategory = createAction(CategoryActions.CREATE_CATEGORY_FAILED, props<{ error: string }>());
export const deleteCategory = createAction(CategoryActions.DELETE_CATEGORY, props<{
  payload: { webshopId: string, categoryId: string }
}>());
export const categoryDeleted = createAction(CategoryActions.DELETE_CATEGORY_SUCCESS, props<{ payload: string }>());
export const cannotDeleteCategory = createAction(CategoryActions.DELETE_CATEGORY_FAILED, props<{ error: string }>());

export const setCategoryDetail = createAction(CategoryActions.SET_CATEGORY_DETAIL, props<{ payload?: string }>());
